import { Table, Box, Button, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../util/axios_instance';



function JournalEntries() {
    const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;
    const location = useLocation();
    const navigate = useNavigate();
    const { journal_id, journal_title } = location.state || {}; // Safe access in case state is undefined

    useEffect(() => {
        fetchData()
    }, [])


    var [journalEntries, setJournalEntries] = useState([]);
    var [count, setCount] = useState(0);
    var [pageNumber, setPageNumber] = useState(0);
    var [rowsPerPage, setRowsPerPage] = useState(10);


    const fetchData = async () => {
        try {
            console.log("calling ", pageNumber);

            const response = await axiosInstance.get(`${BACKEND_HOST}/journal/get_entries/${journal_id}?page=${pageNumber}&size=${rowsPerPage}`, {
                withCredentials: true
            });
            setJournalEntries(response.data.content)
            setCount(response.data.totalElements)
            setPageNumber(response.data.pageable.pageNumber)
            setRowsPerPage(response.data.pageable.pageSize)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchData(); // Call the method
    }, [pageNumber, rowsPerPage]);

    const handleChangePage = async (event, newPage) => {
        console.log("Page change, new page:", newPage);  // Debugging

        setPageNumber(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPageNumber(0);  // Reset to page 0 on rows per page change
    };

    const viewEntry = (journal_id, entry_id) => {
        navigate('/journal_entry', { state: { journal_id, entry_id } });
    }

    const createNewEntry = (journalId) => {
        navigate('/new_entry', { state: { journal_id, journal_title } });
    }

    return (
        <Box display="flex"
            flexDirection={"column"}
            width="80vw" // Set width to 50% of the viewport width
            alignItems={'center'}
            justifyContent={'center'}
            margin={'auto'}
            marginTop={12}
            padding={3}
            borderRadius={5}
            boxShadow={"5px 10px 10px #ccc"}
            sx={{
                ":hover": {
                    boxShadow: "10px 10px 20px #ccc",
                }
            }}>
            <Typography variant='h2' padding={3} textAlign={'center'}>{journal_title}
            </Typography>
            <br />

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Title</TableCell>
                            <TableCell>Created Date</TableCell>
                            <TableCell>View</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {journalEntries.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{item.title}</TableCell>
                                <TableCell>{moment(item.createdDateTime).format('MMMM Do, YYYY')}</TableCell>
                                <TableCell><Button sx={{ borderRadius: 3 }} variant='contained' onClick={() => viewEntry(journal_id, item.entryId)}>View Reflection</Button></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                count={count} // Total number of rows from server
                page={pageNumber}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <Button sx={{ marginTop: 3, borderRadius: 3 }} variant='contained' onClick={() => createNewEntry(journal_id)}>Create a Memory</Button>

        </Box>
    )
}

export default JournalEntries;